import { Component } from '@angular/core';
import { ConfigService } from '@core/services';
import { AccountService, AuthenticationService } from '@features/server-side-authentication';

@Component({
  selector: 'app-page-no-role',
  templateUrl: './page-no-role.component.html',
  styleUrl: './page-no-role.component.scss',
  standalone: false,
})
export class PageNoRoleComponent {
  main_site_url: string;

  constructor(
    private readonly accountService: AccountService,
    private readonly authenticationService: AuthenticationService,
    private readonly configService: ConfigService,
  ) {
    this.main_site_url = this.configService.postLogoutUri;
  }

  get mailToSupport() {
    return `mailto:${this.configService.feedbackEmail}`;
  }

  ngOnInit() {
    this.accountService.clear();
    this.authenticationService.logout().subscribe();
  }
}
